import '../node_modules/patternfly/dist/css/patternfly.css'
import '../node_modules/patternfly/dist/css/patternfly-additions.css'
import '../node_modules/bootstrap-select/dist/css/bootstrap-select.css'

global.jQuery = require('jquery')
global.$ = global.jQuery
require('bootstrap')
require('bootstrap-timepicker')
require('bootstrap-select')
require('patternfly/dist/js/patternfly.min.js')
require('vue-bootstrap-datetimepicker')
